// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 493 ? "bf5f3635" : chunkId) + "." + {"289":"00c6b5d157fc5a29","493":"36f6a317f5610507"}[chunkId] + ".js";
};